<template>
  <v-btn
    :color="color"
    :disabled="disabled"
    :loading="loading"
    :title="text"
    class="cb-button-text-b"
    depressed
    primary
    @click="$emit('click')"
  >
    <v-icon>{{ icon }}</v-icon>
    {{ text }}
  </v-btn>
</template>

<script>
export default {
  name: "ButtonIconTextModelB",
  props: {
    text: String,
    icon: String,
    color: {
      type: String,
      default: "primary"
    },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  }
};
</script>

<style lang="scss">
.cb-button-text-b {
  height: 28px !important;
  width: 120px !important;
  min-width: 120px !important;

  & i {
    margin-right: 4px !important;
  }

  transition: width 1s ease !important;

}

</style>
